
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hshqshiznfwasvgtcjaj.supabase.co';
const supabaseKey = 'sb_publishable_xxWVLD9FFM8DgybrkMlnGg_Gjn3VH6U';

export const supabase = createClient(supabaseUrl, supabaseKey);
